module.exports = __webpack_public_path__ + "static/img/204.fbfe9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/204.png
// module id = 4FnT
// module chunks = 0